<template>
<vue-markdown>
### 订单管理界面的基本功能
![订单管理功能](/assets/docs/manage-orders.png)

#### 1. 文件列表
1. 一个订单包含多少文件， 都会在这里显示
2. 如果第三方公司提供的pdf有问题，可以点击替换按钮替换文件。为了防止失误上传错误的文件，上传文件与被替换的文件名必须相同
3. 份数/大小指的是pdf需要打印多少份，每个pdf的大小
4. 页数栏包含两个页数。比如`12/14`:
  * 前一个数字来自第三方公司传递过来的信息，
  * 后一个数字则是pdf下载完成之后，系统读取该pdf文件获得的页数。
  * 计算订单价格的时候， 用后一个数字的值来计算。
  * 如果pdf页数读取失败，那么用0表示。
  * 对于pdf页数读取失败的订单，拼板也必然会失败。不用担心扣款问题。


### 2. 订单操作

根据权限不同， 下面的按钮部分用户可能不可见
![订单操作](/assets/docs/order-operation.png)

* `更新`：用于更新订单信息， 比如收件人，状态，快递单号，等等。
* `预览快递单`： 如果有快递单，则显示出来。可以用于补打快递单。
* `下载xml`：基本没有用处。
* `计算价格`：实时计算订单的价格，财务修改产品价格后，可以用这个功能测试该订单应该收取多少钱，此功能**并不会实际收取费用**。
* `创建售后`： 不做介绍
* `删除`： 删除一个订单。在第三方公司给出错误订单的订单下， 使用此按钮删除订单。**如果订单已拼板，则依然会扣除相关费用**


#### 3. 订单收费规则
* 拼板后， 订单会被立即收取一笔费用
* 一个订单不管有多少打印任务， 系统只会扣除一笔费用
* 如果因为第三方公司原因重复打印了，可以人工点击`收取费用`按钮再次扣除费用
* 系统扣除和人工扣除的费用都会在订单收费明细显示
* 创建时间大于三十天的订单， 使用`收取费用`扣款会失败
* 每一次手动扣款都会有邮件通知相关人员
* 扣除的款项可以是负数。比如前一操作不小心扣除了错误的金额， 可以输入相同的负数金额销账


</vue-markdown>
</template>

<script>
import VueMarkdown from 'vue-markdown'

export default {
  name: 'help-search-orders',
  components: {
    'vue-markdown': VueMarkdown
  }
}
</script>